import { dateFormatter } from "@services/utils";
import React from "react";
import Image from "next/image";

const getWinDw = (scoreAdversaire: number, scoreDeathrow: number): boolean => {
  return scoreAdversaire > scoreDeathrow ? false : true;
};

type ResultatsProps = {
  adversaire: string;
  adversaireLogo?: string;
  competition: string;
  bestOf?: number;
  dateMatch: string;
  infoSup?: string;
  scoreAdversaire: number;
  scoreDeathrow: number;
  equipeDeathrow: any;
};

const Resultat: React.FC<ResultatsProps> = ({ adversaire, adversaireLogo, competition, bestOf, dateMatch, infoSup, scoreAdversaire, scoreDeathrow, equipeDeathrow }) => {
  return (
    <div id="resultat-card" className="card flex flex-col !bg-blackAccent">
      <div id="resultat-card-container" className="flex-col items-center">
        <div id="resultat-card-header" className="mb-8 flex flex-col justify-between md:flex-row md:space-x-2">
          <div id="resultat-card-header-infos" className="flex flex-col">
            <span className="text-sm font-semibold uppercase line-clamp-1 md:text-xl">{competition}</span>
            <p className="text-ellipsis text-xs font-light text-whiteAccent/70 line-clamp-1 md:text-sm">
              BO{bestOf} {infoSup && `| ${infoSup}`}
            </p>
          </div>
          <span className="text-sm font-light tracking-widest text-redAccent/70 md:text-base">{dateFormatter(dateMatch)}</span>
        </div>
        <div id="resultat-card-body" className="flex flex-row items-center justify-center gap-x-6">
          <div id="resultat-card-body-deathrow" className="flex w-min flex-1 flex-row-reverse items-center justify-start gap-x-2">
            <div id="resultat-card-body-deathrow-score-logo" className="flex flex-row items-center space-x-2">
              <div className="relative h-12 w-12 object-contain">
                <Image placeholder="blur" blurDataURL={"/dw-logo.png"} layout="fill" alt={`Logo DeathroW`} src="/dw-logo.png" />
              </div>
              <span className={`text-3xl ${getWinDw(scoreAdversaire, scoreDeathrow) && "font-bold"}`}>{scoreDeathrow}</span>
            </div>
            <div id="resultat-card-body-deathrow-equipe" className={`text-xs lg:text-sm ${getWinDw(scoreAdversaire, scoreDeathrow) && "font-bold"} text-right`}>
              {equipeDeathrow}
            </div>
          </div>

          <div id="resultat-card-body-adversaire" className="flex w-min flex-1 flex-row items-center justify-start gap-x-2">
            <div id="resultat-card-body-adversaire-score-logo" className="flex flex-row items-center space-x-2">
              <span className={`text-3xl ${!getWinDw(scoreAdversaire, scoreDeathrow) && "font-bold"}`}>{scoreAdversaire}</span>
              {adversaireLogo && (
                <div className="relative h-12 w-12 object-contain">
                  <Image placeholder="blur" blurDataURL={adversaireLogo} layout="fill" alt={`Logo de ${adversaire}`} src={adversaireLogo} />
                </div>
              )}
            </div>
            <div id="resultat-card-body-adversaire-equipe" className={`text-xs lg:text-sm ${!getWinDw(scoreAdversaire, scoreDeathrow) && "font-bold"} text-left`}>
              {adversaire}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Resultat;
